import type { ReactNode } from 'react';
import { useTranslation } from 'next-i18next/pages';
import { Wrapper } from '@ev-tech/ui-core-components/Wrapper';
import { Headline } from '@ev-tech/ui-core-components/Headline';

import { TRANSLATION_NAMESPACE } from '@/i18n/config';
import { useExposeTracking } from '@/hooks/useExposeTracking';
import { useListing } from '@/hooks/queries/useListing';
import { ExpandableCopy } from '@/components/property-expose/ExpandableCopy/ExpandableCopy';

import styles from './LocationText.module.css';

export const LocationText = ({
  locationDescriptionContent,
  location,
}: {
  locationDescriptionContent: ReactNode | null;
  location: string;
}) => {
  const { t } = useTranslation(TRANSLATION_NAMESPACE.property_expose);
  const {
    data: { listing },
  } = useListing();
  const { trackExposeUserInteractionEvent } = useExposeTracking();

  const locationHeadline = t('search.expose.propertyDetails.title.locationDescription', {
    location,
  });

  if (!locationDescriptionContent || !location || !listing) return null;

  return (
    <section data-testid="expose-location-text">
      <Wrapper className={styles.wrapper} width={{ laptop: 'l', tabletLandscape: 'l' }}>
        <Headline size="h5" as="h2" label={locationHeadline} />
        {locationDescriptionContent && (
          <ExpandableCopy
            className={styles.expandableCopy}
            onExpandButtonClick={(isOpen: boolean) =>
              trackExposeUserInteractionEvent({
                elementId: isOpen ? 'location-info_show-less' : 'location-info_show-more',
              })
            }
            content={locationDescriptionContent}
            lines={5}
          />
        )}
      </Wrapper>
    </section>
  );
};
